import axiosAuth from "@/services/axiosAuth";
import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { INVESTMENT_API } from "./apiRoutes";

interface UseGetStrategicInvestmentProps {
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getStrategicInvestment = async () =>
  await axiosAuth.get(`${INVESTMENT_API}/`);

const useGetStrategicInvestment = ({
  queryParams,
}: UseGetStrategicInvestmentProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["strategic-investment"],
    queryFn: () => getStrategicInvestment(),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetStrategicInvestment;
